module.exports = __webpack_public_path__ + "static/media/h5-content.4b310c19.png";